var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.406 119.749L142.408 7.679C151.906 -2.56 168.095 -2.56 177.595 7.679L281.595 119.749C288.08 126.741 289.814 136.933 285.999 145.686C282.189 154.444 273.548 160.104 264.001 160.104H199.999V471.999C199.999 494.093 182.093 511.999 159.999 511.999S119.999 494.093 119.999 471.999V160.104H55.999C46.453 160.104 37.812 154.444 33.998 145.686C30.187 136.933 31.921 126.741 38.406 119.749Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLong);
export default __webpack_public_path__ + "static/media/up-long.c9ca6c1a1c78a24796f8364ce5a71f13.svg";
export { ForwardRef as ReactComponent };